import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterByServiceName',
    pure: false
})
export class FilterByServiceNamePipe implements PipeTransform {
    transform(items: any[], searchText: string): any {
        
        if (!items || !searchText) {
            return items;
        }

        return items.filter(it => {
            return it.name.toLowerCase().includes(searchText.toLowerCase());
        });

        
    }
}